import '../app.js'
import '../app.scss'
